import React,{useContext} from 'react';
import themeContext from "../../../context/theme/ThemeContext";
import { t } from "i18next";

const HeaderTemplateValue = (props) => {
    const { getThemeColor } = useContext(themeContext);
    const style = {
        main :{
            margin: "31px 45px 31px 72px",
            fontFamily: "Open Sans",
            fontStyle: "normal",
            height:"100%"
        },
        box:{
            marginBottom:"25px"
        },
        content:{
            fontSize:"20px",
            fontWeight:"600",
            padding: "0px 0px",
            color: getThemeColor("primary-color"),
            
        },
        htmlContent:{
            borderColor:"1px solid white",
            backgroundColor: "#F2ECEC",
            color: "black",
            height: "92%",
            padding:"10px", 
            borderRadius: "15px",
            // overflowY: "scroll"
        }
    }
  return (
    <>
        <div className='tab-section' style={{height:"100%"}}>
            <section className='sectionA'>
                <p style={style.content}>{'Template'+' '+props.id}</p>
            </section>
            <div style={style.htmlContent}>
                <div
                    dangerouslySetInnerHTML={{__html: props.report}}>
                </div>
            </div>
        </div>
    </>
  )
}

export default HeaderTemplateValue